import {z} from "zod/v4-mini"
import {Three as THREE} from "#material/three/exports"
import {
    closureOutputSchema,
    colorOutputSchema,
    floatOutputSchema,
    materialOutputSchema,
    normalOutputSchema,
    pointOutputSchema,
    vectorOutputSchema,
} from "#material/cycles/schemas"

export const threeNodeOf = <T>() => z.instanceof(THREE.Node) as unknown as z.ZodMiniType<THREE.Node<T>, THREE.Node<T>>

export const materialOutput = z.union([z.instanceof(THREE.Material), materialOutputSchema])
export const materialClosureOutput = z.union([z.instanceof(THREE.Material), closureOutputSchema])
export const materialColorOutput = z.union([threeNodeOf<"color">(), colorOutputSchema])
export const materialFloatOutput = z.union([threeNodeOf<"float">(), floatOutputSchema])
export const materialNormalOutput = z.union([threeNodeOf<"vec3">(), normalOutputSchema])
export const materialPointOutput = z.union([threeNodeOf<"vec3">(), pointOutputSchema])
export const materialVectorOutput = z.union([threeNodeOf<"vec3">(), vectorOutputSchema])
